<template>
    <div style="text-align: center;" :style="{display : is_top_modal ? null : 'none'}">
        <div>
            <div style="font-size: 32px; font-weight: 700; line-height: 46px;">성별을 알려주세요</div>
            <div style="margin-top: 16px; display: flex; flex-direction: column; gap: 12px;">
                <div @click="selectSex('남성')" :style="{ backgroundColor: sex === '남성' ? 'var(--color-main)' : '#fff' }" style="width: 254px; height: 56px; line-height: 56px; border-radius: 12px; background-color: #fff; margin: 0 auto; border: 1px solid #d9d9d9; font-size: 20px; font-weight: 700;">남성</div>
                <div @click="selectSex('여성')" :style="{ backgroundColor: sex === '여성' ? 'var(--color-main)' : '#fff' }" style="width: 254px; height: 56px; line-height: 56px; border-radius: 12px; background-color: #fff; margin: 0 auto; border: 1px solid #d9d9d9; font-size: 20px; font-weight: 700;">여성</div>
            </div>
        </div>
    </div>
</template>

<script>
// import { REGIST_STEP } from '@/Constants';

import {REGIST_STEP} from "../../Constants";

export default {
    name: 'SignupName',
    props: {
        selectSex: {
            type: Function,
            default: () => { }
        },
        sex: {
            type: String,
            default: ''
        },
        mode: {
            type: String,
            default: 'insert'
        },
        registInfo: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {

        }
    },
    computed : {
        is_top_modal(){
            const modal_length = this.$store.state.modals.length;
            if(modal_length > 0){
                const last_modal = this.$store.state.modals[modal_length - 1];
                if(last_modal.view === 'SignupCommonFrame' && this.$hasOwnProperty(last_modal, 'step') && last_modal.step === REGIST_STEP.SEX){
                    return true;
                }
            }

            return false;
        }
    },
    methods: {

    },
    created() {
        if (this.mode === 'update') {
            this.selectSex(this.registInfo.sex)
        }
    }
}
</script>

<style scoped>
.common_input {
    width: 310px;
    height: 56px;
    outline: none;
    border-radius: 12px;
    border: none;
    padding: 0 12px;
}

.common_input::placeholder {
    font-size: 20px;
    font-weight: 500;
    color: #bbbbbb;
}
</style>